import React from 'react';
import { useTranslation } from 'react-i18next';

export default function TokenInput({
    token,
    setToken,
    showToken,
    setShowToken,
    placeholder = '••••••••••••••••',
}) {
    const { t } = useTranslation();

    return (
        <div className="ai-field">
            <label>{t('Clé API')}</label>
            <div className="token-input">
                <input
                    type={showToken ? 'text' : 'password'}
                    className="ai-token-input"
                    value={token}
                    onChange={(e) => setToken(e.target.value)}
                    placeholder={placeholder}
                    autoComplete="off"
                />
                <span onClick={() => setShowToken(!showToken)} role="button" tabIndex={0}>
                    {showToken ? (
                        <img src="/Images/icon-eye-black.png" alt="eye-black" width={14} height={14} />
                    ) : (
                        <img src="/Images/icon-eye-gray.png" alt="eye-gray" width={14} height={14} />
                    )}
                </span>
            </div>
        </div>
    );
}